// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs___Ffux","indicator":"Tabs_indicator__3HWR1"};